module.exports = __webpack_public_path__ + "img/enId.b3e4c1e5.png";